import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-digital-dialog',
  templateUrl: './digital-dialog.component.html',
  styleUrls: ['./digital-dialog.component.scss']
})
export class DigitalDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<DigitalDialogComponent>
  ) { }

  public onClose(value: boolean): void {
    this.dialogRef.close(value);
  }
}
